var prodcat = prodcat || {};
var site = site || {};

prodcat.data = prodcat.data || {};

(function ($, prodcat) {
  Drupal.behaviors.sizePickerChipsV1 = {
    nodes: {},
    attach: function (context) {
      var self = this;

      if (self.attached) {
        return;
      }
      self.attached = true;
      self.nodes.$product = $('.js-product-full', context);
      self.nodes.$sizedOption = $('.js-size-select--chip', self.nodes.$product);
      self.nodes.$productSize = $('.js-product-full-size', self.nodes.$product);
      self.nodes.$productPricePerUnite = $('.js-product-full__ppu', self.nodes.$product);
      if (self.nodes.$sizedOption.length < 1) {
        // if we don't have size chips no need to run the code
        return;
      }
      self.setEvents();
      self.init();
    },
    init: function () {
      var self = this;
      var deepLinkSize = self.getSizeFromUrl();
      var firstSku = deepLinkSize
        ? self.getSkuBySize(deepLinkSize)
        : self.nodes.$product?.data()?.skuBaseId ||
          self.nodes.$sizedOption?.first()?.data()?.skuBaseId;
      if (!!firstSku) {
        // if we don't have any sku's set as default, we select the first size.
        self.nodes.$product.trigger('product.skuSelect', [firstSku]);
      }
    },

    getSizeFromUrl: function () {
      var self = this;
      var urlSize = self.getUrlParam('size');
      if (!!urlSize) {
        urlSize = decodeURIComponent(urlSize);
      }

      return urlSize;
    },

    getProcessedSize: function (size) {
      var processedSized = size.replace(/\s/g, '_');

      processedSized = encodeURIComponent(processedSized).replace(/[!'()*]/g, function (c) {
        return '%' + c.charCodeAt(0).toString(16);
      });

      return processedSized;
    },

    getSkuByProcessedSize: function (productData, size) {
      var self = this;
      // backwards compatible with legacy encoding
      var tmpSkuBaseId = productData.skus.filter(function (skuData) {
        return self.getProcessedSize(skuData.PRODUCT_SIZE) === size;
      });

      return tmpSkuBaseId.length > 0
        ? tmpSkuBaseId[0].SKU_BASE_ID
        : productData.defaultSku.SKU_BASE_ID;
    },

    getSkuBySize: function (size) {
      var self = this;
      var skuBaseId = '';
      var tmpSkuBaseId = [];
      var productData = prodcat.data.getProduct(self.nodes.$product.data('productId'));
      var sizeFound = false;
      if (!!productData && !!productData.skus) {
        tmpSkuBaseId = productData.skus.filter(function (skuData) {
          return skuData.PRODUCT_SIZE === size;
        });
        sizeFound = tmpSkuBaseId.length;
        skuBaseId = sizeFound ? tmpSkuBaseId[0].SKU_BASE_ID : productData.defaultSku.SKU_BASE_ID;
        if (!sizeFound) {
          // backwards compatible with legacy encoding
          skuBaseId = self.getSkuByProcessedSize(productData, size);
        }
      }

      return skuBaseId;
    },

    getUrlParam: function (name) {
      var results = new RegExp('[?&]' + name + '=([^&#]*)').exec(window.location.href);
      var value = null;
      if (!!results) {
        value = decodeURI(results[1]) || 0;
      }
      return value;
    },

    setEvents: function () {
      var self = this;
      self.nodes.$sizedOption.once().on('click', function () {
        var $sizeOptionSelected = $(this);
        var selectedSkuId = $sizeOptionSelected.data('skuBaseId');
        self.nodes.$product
          .trigger('product.skuSelect', [selectedSkuId])
          .trigger('product.updateRoute', selectedSkuId);
      });
      $(document).on('product.skuSelect', '.js-product-ui', function (e, skuBaseId) {
        var chip = self.nodes.$sizedOption.filter('[data-sku-base-id=' + skuBaseId + ']');

        if (chip.length !== 0) {
          self.selectSizeChip(chip);
          self.setProductSize(skuBaseId);
        }
      });
    },
    selectSizeChip: function ($chip) {
      var self = this;
      self.nodes.$sizedOption.removeClass('selected');
      $chip.addClass('selected');
    },
    setProductSize: function (skuBaseId) {
      var self = this;
      var skuData = prodcat.data.getSku(skuBaseId);
      // Change product size
      if (!!skuData?.PRODUCT_SIZE) {
        self.nodes.$productSize.length > 0 && self.nodes.$productSize.text(skuData.PRODUCT_SIZE);
        self.nodes.$productPricePerUnite.length > 0 &&
          self.nodes.$productPricePerUnite.text(skuData.formattedUnitPrice);
      }
    },
    attached: false
  };
})(jQuery, window.prodcat || {});
